import * as React from 'react'
const SvgCloudUploadIcon = (props) => (
  <svg
    className="mx-auto h-12 w-12 text-gray-400"
    width="46"
    height="47"
    viewBox="0 0 46 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="3" y="3.87988" width="40" height="40" rx="20" fill="#F2F4F7" />
    <path
      d="M19.6666 27.2132L23 23.8799M23 23.8799L26.3333 27.2132M23 23.8799V31.3799M29.6666 27.8322C30.6845 26.9916 31.3333 25.7198 31.3333 24.2965C31.3333 21.7652 29.2813 19.7132 26.75 19.7132C26.5679 19.7132 26.3975 19.6182 26.3051 19.4613C25.2183 17.6172 23.212 16.3799 20.9166 16.3799C17.4648 16.3799 14.6666 19.1781 14.6666 22.6299C14.6666 24.3516 15.3628 25.9108 16.4891 27.0412"
      stroke="#475467"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="3"
      y="3.87988"
      width="40"
      height="40"
      rx="20"
      stroke="#F9FAFB"
      strokeWidth="6"
    />
  </svg>
)
export default SvgCloudUploadIcon
